import axios from "axios";
import { emitCheckDatabaseStatus } from "./socketHelpers";

export const checkDatabaseStatus = async (socket) => {
  try {
    const response = await emitCheckDatabaseStatus(socket, {});
    if (response.status === true && response.data) {
      return response.data;
    }
    return "Bad";
  } catch (error) {
    return "Bad";
  }
};

export const measureUploadSpeed = async () => {
  const data = "x".repeat(5 * 1024 * 1024);
  const startTime = performance.now();
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/upload-speed`,
      data,
      {
        headers: {
          "Content-Type": "application/octet-stream",
          "Content-Length": data.length,
        },
        timeout: 30000,
      }
    );
    if (response.status !== 200) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const endTime = performance.now();
    const duration = (endTime - startTime) / 1000;

    // Formula: (bytes * 8 bits/byte) / (1024 * 1024 bits/Mb) / seconds = Mbps
    const speedMbps = (data.length * 8) / (1024 * 1024) / duration;
    return speedMbps.toFixed(2);
  } catch (error) {
    return 0;
  }
};

export const measurePingAndPacketLoss = async () => {
  const pings = [];
  const totalRequests = 5;

  for (let i = 0; i < totalRequests; i++) {
    try {
      const startTime = performance.now();
      const response = await fetch(`${process.env.REACT_APP_API_URL}/ping`, {
        method: "GET",
        cache: "no-cache",
      });
      const endTime = performance.now();

      if (response.ok) {
        const pingTime = endTime - startTime;
        pings.push(pingTime);
      }
    } catch (error) {
      // Don't return on first failure; one blip shouldn't force "Lost"
    }
    if (i < totalRequests - 1) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  }

  const successfulRequests = pings.length;
  const packetLoss =
    ((totalRequests - successfulRequests) / totalRequests) * 100;
  const avgPing =
    pings.length > 0 ? pings.reduce((a, b) => a + b, 0) / pings.length : 0;
  const ping = pings.length > 0 ? Number(avgPing.toFixed(0)) : 300;

  return {
    ping,
    packetLoss: Number(packetLoss.toFixed(1)),
  };
};

export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};
